import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  isFinal?: boolean;
}
const scrollToFinalCTA = () => {
  const el = document.getElementById('final-cta');
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
};
export const CTAButton: React.FC<CTAButtonProps> = ({
  children,
  onClick,
  className = '',
  isFinal = false
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    if (isFinal) {
      trackAddToCart({
        value: 27,
        currency: 'USD'
      });
      // Small delay to allow the pixel event to fire before navigating away
      setTimeout(() => {
        window.location.href = 'https://guiasparavivir.com/cart/52636298936609:1';
      }, 200);
      return;
    }
    scrollToFinalCTA();
  };
  return <motion.button whileHover={{
    scale: 1.02,
    boxShadow: '0 0 25px rgba(245, 197, 66, 0.4)'
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative overflow-hidden group
        bg-gradient-to-b from-amber-400 to-amber-600
        text-cosmic-900 font-serif font-bold text-xl md:text-2xl
        px-10 py-5 rounded-sm tracking-wide
        shadow-[0_0_15px_rgba(245,197,66,0.2)]
        transition-all duration-300
        cursor-pointer
        ${className}
      `} data-id="element-166">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-167">
        {children}
      </span>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-168" />
    </motion.button>;
};